export interface AccountMenuItem {
  icon: string;
  title: string;
  route: string;
  roles: string[];
}

export const accountMenuItems: AccountMenuItem[] = [
  {
    title: 'My Dashboard',
    icon: 'dashboard-solid',
    route: '/account/dashboard',
    roles: ['AS1', 'AS2', 'AS3', 'AS4'],
  },
  {
    title: 'Link Account',
    icon: 'link',
    route: '/account/link',
    roles: ['AS3'],
  },
  {
    title: 'Manage Profile',
    icon: 'person-solid',
    route: '/account/profile',
    roles: ['AS1', 'AS2', 'AS3', 'AS4'],
  },

  {
    title: 'Manage Account',
    icon: 'gear-solid',
    route: '/account/manage',
    roles: ['AS1', 'AS2', 'AS4'],
  },
  {
    title: 'Notifications',
    icon: 'bell-solid',
    route: '/account/notifications',
    roles: ['AS1', 'AS2', 'AS4'],
  },
  {
    title: 'Services',
    icon: 'calendar-day-outline',
    route: '/account/services',
    roles: ['AS1', 'AS2'],
  },
  {
    title: 'Services',
    icon: 'calendar-day-outline',
    route: 'https://www.lacitysan.org',
    roles: ['AS4'],
  },
  {
    title: 'Payments',
    icon: 'dollar-sign-solid',
    route: '/account/payment',
    roles: ['AS1', 'AS4'],
  },
  {
    title: 'Auto Pay',
    icon: 'alarm',
    route: '/account/manage/auto-pay',
    roles: ['AS1', 'AS4'],
  },
  {
    title: 'Support',
    icon: 'question-circle-outline',
    route: 'https://www.lacitysan.org/san/faces/home',
    roles: ['AS4'],
  },
];
